module.exports = __webpack_public_path__ + "img/aifxjz-3-sm.05c781d9.jpg";